import DatetimeHelperService from './datetime-helper-service';

/***
 * A Service with helper functions for handling Date and moment objects.
 */
const datetimeHelper = angular
    .module('FacilityData.Common.DatetimeHelper', [])
    .service('DatetimeHelper', DatetimeHelperService)
    .name;

export default datetimeHelper;


// WEBPACK FOOTER //
// ./app/common/datetime-helper/datetime-helper.js